import { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Header.module.css';

const NAV = [
  { label: 'Features',      href: '/#features' },
  { label: 'Pricing',       href: '/#pricing'  },
  { label: 'Support',       href: '/#support'  },
  { label: 'Player Guide',  to:   '/docs'       },
];

export default function Header() {
  const [open,      setOpen]      = useState(false);
  const [scrolled,  setScrolled]  = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const headerClass = [
    styles.header,
    scrolled ? styles.headerScrolled : '',
  ].filter(Boolean).join(' ');

  return (
    <header className={headerClass}>
      <div className={styles.inner}>

        {/* Logo */}
        <Link to="/" className={styles.logo} onClick={() => { setOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
          <img src="/g_logo.png" alt="Golf Scores" className={styles.logoImg} />
          <div className={styles.logoDivider} />
          <div className={styles.logoStack}>
            <span className={styles.logoText}>Golf-<span className={styles.logoAccent}>Scores.com</span></span>
            <span className={styles.logoSub}>Live tournament scoring</span>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className={styles.desktopNav}>
          {NAV.map(item =>
            item.to
              ? <NavLink key={item.label} to={item.to}
                  className={({ isActive }) =>
                    [styles.navLink, isActive && styles.navLinkActive].filter(Boolean).join(' ')
                  }>{item.label}</NavLink>
              : <a key={item.label} href={item.href} className={styles.navLink}>
                  {item.label}
                </a>
          )}
          <Link to="/admin" className={styles.ctaBtn}>
            Director Portal
          </Link>
        </nav>

        {/* Mobile hamburger */}
        <button
          className={styles.hamburger}
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <svg className={styles.hamburgerIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {open
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            }
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className={styles.mobileMenu}>
          {NAV.map(item =>
            item.to
              ? <NavLink key={item.label} to={item.to} onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    [styles.mobileNavLink, isActive && styles.mobileNavLinkActive].filter(Boolean).join(' ')
                  }>{item.label}</NavLink>
              : <a key={item.label} href={item.href} onClick={() => setOpen(false)}
                  className={styles.mobileNavLink}>
                  {item.label}
                </a>
          )}
          <Link to="/admin" onClick={() => setOpen(false)} className={styles.mobileCtaBtn}>
            Director Portal
          </Link>
        </div>
      )}
    </header>
  );
}
